import { DefaultApi } from '~services/api';

export const TRACKING_ENDPOINT = '/public/onboarding-nca/tracking';

export interface TrackingClient {
  post<T>(url: string, body: unknown): Promise<T>;
}

export const representativeTrackingEndpoint = (representativeId: string) =>
  `/public/representatives/${encodeURIComponent(representativeId)}/tracking`;

export const representativeTrackingHttpClient = (): TrackingClient => ({
  post<T>(url: string, events: unknown): Promise<T> {
    return DefaultApi.request<T>(url, {
      method: 'POST',
      data: { events },
    }) as Promise<T>;
  },
});

/**
 * O SDK entrega um array cru; a rota espera `{ link, events: [...] }`. O uuid
 * vai no corpo, ao lado do lote, porque um header customizado exigiria liberação
 * na allowlist de CORS do ingress, que é compartilhada entre serviços.
 */
export const trackingHttpClient = (link: string): TrackingClient => ({
  post<T>(url: string, events: unknown): Promise<T> {
    return DefaultApi.request<T>(url, {
      method: 'POST',
      data: { link, events },
    }) as Promise<T>;
  },
});
